module.exports = __webpack_public_path__ + "img/add-folder.1a5e2a2d.svg";